import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function AboutGbts(props) {
  const { isMobile } = props;
  const { t, i18n } = useTranslation();

  return (
    <div className="p-xl-5">
      <div className="text-center mb-4">
        <h2 className="font-weight-900 mt-3 mt-xl-0 mb-2 lineUp">
          {t("aboutGbts.title")} <span className="text-freiscop">GBTS</span>
        </h2>
        <h4 className="font-weight-600">
          <p className="px-2 px-xl-0">
            <span className="text-freiscop font-weight-800">
              {t("aboutGbts.digitalTransformation")}
            </span>
            {t("aboutGbts.description")}
          </p>
        </h4>
      </div>
      <div className="p-3 mb-3 mx-3 mx-xl-0 bg-light">
        <div className="d-flex flex-column flex-xl-row justify-content-start align-items-center mb-3">
          <p
            className="h6 m-0 mb-2 mb-xl-0 py-2 px-4 border border-dark bg-white font-weight-900 text-center"
            style={{ minWidth: 150 }}
          >
            {t("aboutGbts.currentWorkflow")}
          </p>
          <div className="py-2 px-xl-4 h6 m-0">
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">①</span>{" "}
              <p>{t("aboutGbts.currentStep1")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">②</span>{" "}
              <p>{t("aboutGbts.currentStep2")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">③</span>{" "}
              <p>{t("aboutGbts.currentStep3")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">④</span>
              <p>{t("aboutGbts.currentStep4")}</p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center mb-3">
          <img
            height={isMobile ? "auto" : "200px"}
            width={isMobile ? "80%" : "auto"}
            src="/img/info/before_process.png"
            alt="before_process"
          />
        </div>
      </div>
      <div className="p-3 mb-3 mx-3 mx-xl-0 bg-freiscop-10">
        <div className="d-flex flex-column flex-xl-row justify-content-start align-items-center mb-3">
          <p
            className="py-2 px-4 h6 m-0 mb-2 mb-xl-0  border border-dark bg-white font-weight-900 text-center"
            style={{ minWidth: 150 }}
          >
            {t("aboutGbts.gbtsWorkflow")}
          </p>
          <div className="py-2 px-xl-4 h6 m-0 ">
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">①</span>
              <p>{t("aboutGbts.gbtsStep1")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">②</span>
              <p>{t("aboutGbts.gbtsStep2")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">③</span>
              <p>{t("aboutGbts.gbtsStep3")}</p>
            </div>
            <div className="d-inline-flex flex-row mb-1 mb-xl-0 mr-xl-2">
              <span className="font-weight-bold mr-1">④</span>
              <p>{t("aboutGbts.gbtsStep4")}</p>
            </div>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-center mb-3">
          <img
            height={isMobile ? "auto" : "200px"}
            width={isMobile ? "80%" : "auto"}
            src="/img/info/gbts_process.png"
            alt="before_process"
          />
        </div>
      </div>
    </div>
  );
}
